import request from '../apiService';

// Ordena recursivamente los items de menú por la propiedad `ord`.
// Los items sin `ord` se colocan al final de su lista.
const sortMenu = (items) => {
	if (!Array.isArray(items)) return items;
	return items
		.map(item => ({ ...item, sub: sortMenu(item.sub) }))
		.sort((a, b) => {
			const aOrd = typeof a.ord === 'number' ? a.ord : Number.POSITIVE_INFINITY;
			const bOrd = typeof b.ord === 'number' ? b.ord : Number.POSITIVE_INFINITY;
			return aOrd - bOrd;
		});
};

// Funciones centralizadas en API Service
const getMenu = async () => {
	const data = await request('/api/v1/configuracion/menu-usuario');
	return sortMenu(data);
};

const getCatalogos = async () => request('/api/v1/configuracion/usuarios/catalogos');
const getUsuarios = async () => request('/api/v1/configuracion/usuarios');
const getUsuario = async (id) => request(`/api/v1/configuracion/usuarios/${id}`);
const addUsuario = async (usuario) => request('/api/v1/configuracion/usuarios', 'POST', usuario);
const updateUsuario = async (id, updates) => request(`/api/v1/configuracion/usuarios/${id}`, 'PUT', updates);
const deleteUsuario = async (id) => request(`/api/v1/configuracion/usuarios/${id}`, 'DELETE');
const updateUsuarioPassword = async (passwords) => request(`/api/v1/configuracion/usuarios/clave`, 'POST', passwords);
const updateUsuarioBasic = async (updates) => request(`/api/v1/configuracion/usuarios/basic`, 'POST', updates);

export { getCatalogos, getUsuarios, getUsuario, addUsuario, updateUsuario, deleteUsuario, updateUsuarioPassword, updateUsuarioBasic, getMenu };